import axios from '../axios/redditlikeApi'

const fetchCommunities = () => axios.get('/communities')

const fetchJoinedCommunities = () => axios.get('/communities/joined')

const getCommunityById = id => axios.get(`/communities/${id}`)

const createCommunity = form => axios.post('/communities', form)

const deleteCommunity = id => axios.delete(`/communities/${id}`)

const updateCommunity = (id, form) => axios.patch(`/communities/${id}`, form)

const joinCommunity = id => axios.patch(`/communities/join/${id}`)

export default {
  fetchCommunities,
  fetchJoinedCommunities,
  getCommunityById,
  createCommunity,
  deleteCommunity,
  updateCommunity,
  joinCommunity
}
